import { LabelsForInput } from 'components/LabelsForInputs'
import { TextArea } from 'components/TextArea'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { NotificationReducer } from 'types/notification'
import { getCorIncidente, getDamage } from 'utils/damage'
import { textAreaSmallStyles } from '../NotificationData/styles'
import { useForm } from 'react-hook-form'
// import { ButtonAction, actionsBack } from './styles'
import ActionStatus from 'components/ActionStatus'
import { useMemo } from 'react'
import { stringToDate } from 'utils/dateUtils'

interface TreatmentStep5Props {
    tooltipAlert: string
}
const ArchivedStep = ({ tooltipAlert }: TreatmentStep5Props) => {
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const notification = useMemo(
        () => notificationSelector?.notificationById,
        [notificationSelector]
    )

    const { register } = useForm()
    return (
        <div data-testid="test-step5" className='pb-6'>
            <div className="px-8 flex flex-row gap-12 mt-4">
                <div className="flex flex-col">
                    <span className="text-xs">Chave da notificação</span>
                    <span className="text-sm font-bold">
                        {notification?.number?.display_value?.toUpperCase()}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Data da ocorrência</span>
                    <span className="font-semibold text-sm">
                        {notification?.date_incident?.display_value}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Unidade</span>
                    <span className="font-semibold text-sm">
                        {notification?.location_incident?.display_value}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Setor</span>
                    <span className="font-semibold text-sm">
                        {notification?.incident_sector?.display_value}
                    </span>
                </div>
            </div>
            <div className="px-8 flex flex-row gap-12 mt-4">
                <div className="flex flex-col">
                    <span
                        className={`chip-incidente incidente-${getCorIncidente(
                            getDamage(notification?.damage_level?.value)?.value
                        )}`}
                    >
                        {`${
                            getDamage(notification?.damage_level?.value)?.label
                        }`}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Título do incidente</span>
                    <span className="font-semibold text-sm">
                        {notification?.incident_title?.display_value}
                    </span>
                </div>
            </div>
            <div className="h-px w-full my-2 bg-gray-200 mx-8 mt-4" />

            {tooltipAlert && (
                <div className="px-6"  data-testid="test-step5-tooltip">
                    <ActionStatus text={tooltipAlert} status={1} />
                </div>
            )}
            <div className="px-8 flex flex-row gap-12 mt-4">
                <div className="flex flex-col">
                    <span className="text-xs">Arquivada por</span>
                    <span className="text-sm font-bold">
                        {notification?.u_assigned_to?.display_value}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Motivo</span>
                    <span className="font-semibold text-sm">
                    {notification?.u_reason_for_archiving?.display_value}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-xs">Observação</span>
                    <span className="font-semibold text-sm">
                     {notification?.u_archiving_observations?.display_value}
                    </span>
                </div>
            </div>
            {/* <div className="px-8 mt-8">
                <div className="max-w-[552px]">
                    <LabelsForInput
                        styles={
                            {
                                titleStyle:'text-blueTheme'
                            }
                        }
                        title="Comentários"
                        subtitle="Adicionar comentário na notificação"
                    />
                    <TextArea
                        register={register}
                        name="mitigating_factors"
                        className={textAreaSmallStyles}
                        placeholder="Digite aqui"
                        rows={4}
                    />
                    <ButtonAction
                        type="button"
                        onClick={() => {}}
                        className={actionsBack}
                    >
                        Enviar comentário
                    </ButtonAction>
                </div>
            </div> */}
        </div>
    )
}

export { ArchivedStep }
